import React, { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { BRAND, VIDEOS, IMG } from '../lib/butterstone';

const HeroContent = ({ light = true }) => (
  <div className={`max-w-3xl ${light ? 'text-white' : 'text-[#1E3226]'}`}>
    <span className="drift-in inline-block text-[11px] md:text-xs tracking-[0.34em] uppercase mb-5" style={{ color: light ? '#AFC2A4' : '#4F7343' }}>
      {BRAND.group}
    </span>
    <h1 className="drift-in font-serif font-light leading-[0.98] text-4xl sm:text-5xl md:text-7xl" style={{ color: light ? '#fff' : '#1E3226' }}>
      Butterstone<br />River Valley
    </h1>
    <p className="drift-in mt-5 md:mt-6 text-base md:text-lg font-light max-w-xl" style={{ color: light ? 'rgba(255,255,255,0.88)' : '#3A4A3E' }}>
      A premium riverside retreat and coffee estate tucked into the Western Ghats of Sakleshpur — with a river flowing through the property and a viewpoint over the valley.
    </p>
    <div className="drift-in mt-8 flex flex-wrap gap-3">
      <button className="btn-light" onClick={() => document.querySelector('#stay')?.scrollIntoView({ behavior: 'smooth' })} data-testid="hero-book-btn">Book Your Stay</button>
      <button className={light ? 'btn-outline' : 'btn-outline'} style={light ? { color: '#fff', borderColor: 'rgba(255,255,255,0.5)' } : {}} onClick={() => document.querySelector('#activities')?.scrollIntoView({ behavior: 'smooth' })}>Explore Activities</button>
    </div>
  </div>
);

const HeroSection = ({ onVideoReady }) => {
  const firedRef = useRef(false);
  const [failed, setFailed] = useState(false);
  const ready = () => { if (!firedRef.current) { firedRef.current = true; onVideoReady && onVideoReady(); } };

  return (
    <section id="top" className="relative bg-[#12201a]" data-testid="hero-section">
      {/* DESKTOP — full-bleed cover video with overlaid text */}
      <div className="hidden md:block relative h-screen w-full overflow-hidden">
        {!failed && (
          <video className="hero-video absolute inset-0" autoPlay muted loop playsInline poster={IMG.riverAerial}
            onLoadedData={ready} onCanPlay={ready} onError={() => { setFailed(true); ready(); }}>
            <source src={VIDEOS.hero} type="video/mp4" />
          </video>
        )}
        {failed && <img src={IMG.riverAerial} alt="Butterstone River Valley" className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(18,32,26,0.45) 0%, rgba(18,32,26,0.15) 40%, rgba(18,32,26,0.75) 100%)' }} />
        <div className="relative z-10 h-full flex items-end">
          <div className="max-w-7xl w-full mx-auto px-8 pb-20"><HeroContent light /></div>
        </div>
      </div>

      {/* MOBILE — landscape video kept in 16:9 (never cropped), text below */}
      <div className="md:hidden">
        <div className="w-full aspect-video bg-[#12201a] overflow-hidden mt-16">
          {!failed ? (
            <video className="w-full h-full object-cover" autoPlay muted loop playsInline poster={IMG.riverAerial}
              onLoadedData={ready} onCanPlay={ready} onError={() => { setFailed(true); ready(); }}>
              <source src={VIDEOS.hero} type="video/mp4" />
            </video>
          ) : (
            <img src={IMG.riverAerial} alt="Butterstone River Valley" className="w-full h-full object-cover" />
          )}
        </div>
        <div className="bg-[#1E3226] px-6 py-10"><HeroContent light /></div>
      </div>

      <div className="hidden md:flex absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex-col items-center text-white/70">
        <span className="text-[10px] tracking-[0.3em] uppercase mb-1">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
